module.exports = __webpack_public_path__ + "static/media/tdsEngland.1a0fad3e.png";